
import { Injectable } from '@angular/core';


@Injectable()
export class ScansHistoryProvider {
  anprs: string[];
  ocrs: string[];
  qrs: string[];
  lastANPR: string;
  lastOCR: string;
  lastQR: string;

  constructor() {

  }

  init(source:string=''){
    if (source==null || source=='') {
      this.anprs=[];
      this.ocrs=[];
      this.qrs=[];
      console.log('Historias inicializadas');
    }
  }

 push(arr:string,str:string){
     switch(arr){
      case 'anprs': {
        this.anprs.push(str);
        this.lastANPR=str;
      }
      case 'ocrs': {
        this.ocrs.push(str);
        this.lastOCR=str;
      }
      case 'qrs': {
        this.qrs.push(str);
        this.lastQR=str;
      }
    }

    console.log(arr,str);  
    //Hacer algo como esto: this.home.evento(arr,str);
  }


  get(arr:string):string{
    let str='';
    switch(arr){
      case 'anprs': {
        str=this.lastANPR;
      }
      case 'ocrs': {
        str=this.lastOCR;
      }
      case 'qrs': {
        str=this.lastQR;
      }
    }  
    console.log('get '+arr,str);
    return str;
  }

}


// WEBPACK FOOTER //
// ./src/providers/scans-history/scans-history.ts